import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import DossiersList from "@/pages/DossiersList";
import DossierCreate from "@/pages/DossierCreate";
import DossierDetail from "@/pages/DossierDetail";
import Simulateur from "@/pages/Simulateur";
import Simulateur174 from "@/pages/Simulateur174";
import SimulateurProfil from "@/pages/SimulateurProfil";
import SimulateurTravaux from "@/pages/SimulateurTravaux";
import SettingsPage from "@/pages/SettingsPage";
import DashboardRegie from "@/pages/DashboardRegie";
import EtudesRegie from "@/pages/EtudesRegie";
import EtudeDetail from "@/pages/EtudeDetail";
import PlanningRegie from "@/pages/PlanningRegie";
import DossiersRegie from "@/pages/DossiersRegie";
import DossierRegieDetail from "@/pages/DossierRegieDetail";
import InjectionPdf from "@/pages/InjectionPdf";
import MapFrance from "@/pages/MapFrance";
import LeadsPage from "@/pages/LeadsPage";
import LeadDetail from "@/pages/LeadDetail";
import PlanningPage from "@/pages/PlanningPage";
import ClientUploadPage from "@/pages/ClientUploadPage";
import Login, { isAuthenticated } from "@/pages/Login";
import Layout from "@/components/Layout";

function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Public route for client document upload */}
          <Route path="/client-upload/:token" element={<ClientUploadPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dossiers" element={<DossiersList />} />
            <Route path="dossiers/new" element={<DossierCreate />} />
            <Route path="dossiers/:id" element={<DossierDetail />} />
            <Route path="carte" element={<MapFrance />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="planning" element={<PlanningPage />} />
            <Route path="simulateur" element={<Simulateur />} />
            <Route path="simulateur-174" element={<Simulateur174 />} />
            <Route path="simulateur-profil" element={<SimulateurProfil />} />
            <Route path="simulateur-travaux" element={<SimulateurTravaux />} />
            <Route path="parametres" element={<SettingsPage />} />
            <Route path="dashboard-regie" element={<DashboardRegie />} />
            <Route path="etudes-regie" element={<EtudesRegie />} />
            <Route path="etude/:id" element={<EtudeDetail />} />
            <Route path="planning-regie" element={<PlanningRegie />} />
            <Route path="dossiers-regie" element={<DossiersRegie />} />
            <Route path="dossier-regie/:id" element={<DossierRegieDetail />} />
            <Route path="injection-pdf" element={<InjectionPdf />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
